import { render, staticRenderFns } from "./notWxInner.vue?vue&type=template&id=54198abe&scoped=true"
import script from "./notWxInner.vue?vue&type=script&lang=js"
export * from "./notWxInner.vue?vue&type=script&lang=js"
import style0 from "./notWxInner.vue?vue&type=style&index=0&id=54198abe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54198abe",
  null
  
)

export default component.exports